import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

export type BadgeTone = 'gray' | 'green' | 'red' | 'yellow' | 'blue' | 'purple' | 'brand';

const TONE: Record<BadgeTone, string> = {
  gray: 'bg-gray-100 text-gray-600',
  green: 'bg-green-100 text-green-700',
  red: 'bg-red-100 text-red-600',
  yellow: 'bg-yellow-100 text-yellow-700',
  blue: 'bg-blue-100 text-blue-700',
  purple: 'bg-purple-100 text-purple-700',
  brand: 'bg-brand-primary-light text-brand-primary',
};

export function Badge({
  tone = 'gray',
  className,
  ...rest
}: HTMLAttributes<HTMLSpanElement> & { tone?: BadgeTone }) {
  return <span className={cn('badge', TONE[tone], className)} {...rest} />;
}

const STATUS_TONES: Record<string, BadgeTone> = {
  queued: 'gray',
  pending: 'gray',
  running: 'yellow',
  active: 'green',
  done: 'green',
  cached: 'brand',
  qualified: 'green',
  up: 'green',
  ok: 'green',
  failed: 'red',
  error: 'red',
  down: 'red',
  paused: 'yellow',
  bounced: 'red',
  no_reply: 'gray',
  replied: 'purple',
  unsubscribed: 'gray',
};

export function StatusBadge({ status }: { status: string | null | undefined }) {
  const value = (status ?? 'unknown').toLowerCase();
  const tone = STATUS_TONES[value] ?? 'gray';
  return <Badge tone={tone}>{value}</Badge>;
}
